import React, { Component } from "react";
import "./OnDemandPlaying.css";

class OnDemandPlaying extends Component {
  componentDidMount() {
    // Add click handler for the expanded camera button
    const buttonExpandCamera = document.getElementById('buttonExpandCamera');
    if (buttonExpandCamera) {
      buttonExpandCamera.addEventListener('click', () => {
        // Use the active movement-test command when available so button
        // clicks follow the same path as voice/chat START_TEST.
        if (window.currentCommandsAudio?.START_TEST) {
          window.currentCommandsAudio.START_TEST();
        } else if (window.tipsClickNext) {
          window.tipsClickNext();
        }
      });
    }

    if (this.isElectron()) {
      // Show loader when component mounts (Flutter will load)
      this.showLoader();
      this.loaderTimeout = setTimeout(() => {
        this.hideLoader();
      }, 10000);
    }
  }

  componentWillUnmount() {
    // Clean up
    this.hideLoader();
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout);
    }
  }

  isElectron() {
    return window.navigator.userAgent.indexOf("Electron") > -1;
  }

  showLoader() {
    const loader = document.getElementById("flutter-loader");
    if (loader) {
      loader.style.display = "block";
    }
  }

  hideLoader() {
    const loader = document.getElementById("flutter-loader");
    if (loader) {
      loader.style.display = "none";
    }
  }

  allowCustomCamera() {
    if (!window.getUserPermission) { return false; }

    if (window.getLastPickedCamera) {
      var pickedCamera = window.getLastPickedCamera();
      window.getUserPermission(pickedCamera, false, () => { });
    } else {
      window.getUserPermission(false, false, () => { });
    }
  }

  render() {
    const isElectron = window.navigator.userAgent.indexOf("Electron") > -1;
    const isSelfPart = !!localStorage.getItem('loadSelf');
    return (
      <div style={{ display: isElectron ? "block" : "none" }} id="OnDemandPlayingRoot">
        <div id="player_ondemand"></div>
        <div id="agora_ondemand_local"></div>
        <div id="buttonExpandCamera">{isSelfPart ? 'Start the Movement Test' : 'Start Exercise'}</div>
        <div id="agora_ondemand_local_waiting">
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="d_block">Getting camera access, please wait…</div>
          <div className="agora_ondemand_local_allow" onClick={() => { this.allowCustomCamera(); }}>Allow Camera</div>
        </div>
        <div id="ondemand_virtual_canvas">
          <canvas id="canvas-user" width="1280" height="720"></canvas>
          <canvas id="canvas-flutter" width="1280" height="720"></canvas>
        </div>
      </div>
    );
  }
}

export default OnDemandPlaying;
